const MuiTypography = {
    gutterBottom: {
        marginBottom: 8
    }
};
export default MuiTypography;